module.exports = __webpack_public_path__ + "img/Eduzz-6-en.4e11b60a.png";